<template>
  <div class="columns onboarding-wrap">
    <div class="onboarding">
      <div class="scroll-wrap">
        <div class="features-item">
          <h1 class="page-title">
            <span class="text-black-900 dark:text-slate-200 font-extrabold">{{
              $t('ONBOARDING.TITLE', {
                installationName: globalConfig.installationName,
              })
            }}</span>
          </h1>
          <p class="intro-body">
            {{
              $t('ONBOARDING.DESCRIPTION', {
                installationName: globalConfig.installationName,
              })
            }}
          </p>
          <p v-if="globalConfig.installationName === 'Chatwoot'">
            <a
              href="https://www.chatwoot.com/changelog"
              target="_blank"
              rel="noopener nofollow noreferrer"
              class="onboarding--link"
            >
              {{ $t('ONBOARDING.READ_LATEST_UPDATES') }}
            </a>
            <span>🎉</span>
          </p>
        </div>
        <div class="features-item">
          <h2 class="block-title text-black-900 dark:text-slate-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              class="emoji"
            >
              <path
                d="M0.858927 6.77182C1.41261 5.45035 2.21811 4.24922 3.23053 3.23538C4.23993 2.21978 5.43897 1.41232 6.75957 0.858837C8.11242 0.289087 9.56597 -0.00296723 11.0339 2.27273e-05H11.0833C12.5763 0.0074263 14.02 0.303569 15.3798 0.885983C16.6891 1.44514 17.8768 2.25403 18.8767 3.26746C19.8794 4.27902 20.6756 5.47595 21.2212 6.79156C21.7875 8.15965 22.0745 9.6272 22.0652 11.1078C22.0578 12.8205 21.6481 14.5209 20.8831 16.0411V19.7922C20.8831 20.4191 20.3747 20.9274 19.7504 20.9274H16.0042C14.4769 21.6981 12.7915 22.1036 11.0808 22.112H11.029C9.55318 22.112 8.12429 21.8257 6.77684 21.2655C5.46292 20.7187 4.26837 19.9206 3.26015 18.9161C2.24339 17.9068 1.44381 16.7272 0.883606 15.4118C0.303659 14.0495 0.00751495 12.6009 0.000110626 11.1054C-0.00482368 9.60245 0.286385 8.14395 0.858927 6.77182ZM15.9597 12.2406C16.6112 12.2406 17.1418 11.71 17.1418 11.056C17.1418 10.402 16.6112 9.87145 15.9597 9.87145C15.3082 9.87145 14.7776 10.402 14.7776 11.056C14.7776 11.71 15.3058 12.2406 15.9597 12.2406ZM11.0339 12.2406C11.6854 12.2406 12.216 11.71 12.216 11.056C12.216 10.402 11.6854 9.87145 11.0339 9.87145C10.3824 9.87145 9.85179 10.402 9.85179 11.056C9.85179 11.71 10.3824 12.2406 11.0339 12.2406ZM6.10806 12.2406C6.75957 12.2406 7.29016 11.71 7.29016 11.056C7.29016 10.402 6.75957 9.87145 6.10806 9.87145C5.45654 9.87145 4.92595 10.402 4.92595 11.056C4.92595 11.71 5.45654 12.2406 6.10806 12.2406Z"
                fill="#4c5155"
              />
            </svg>
            <span class="conversation--title">{{
              $t('ONBOARDING.ALL_CONVERSATION.TITLE')
            }}</span>
          </h2>
          <p class="intro-body">
            {{ $t('ONBOARDING.ALL_CONVERSATION.DESCRIPTION') }}
          </p>
        </div>
        <div class="features-item">
          <h2 class="block-title text-black-900 dark:text-slate-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              class="emoji"
            >
              <path
                d="M22.9167 5.20833V4.16667C22.9167 3.59375 22.4479 3.125 21.875 3.125C21.3021 3.125 20.8333 3.59375 20.8333 4.16667V5.20833H19.7917C19.2188 5.20833 18.75 5.67708 18.75 6.25C18.75 6.82292 19.2188 7.29167 19.7917 7.29167H20.8333V8.33333C20.8333 8.90625 21.3021 9.375 21.875 9.375C22.4479 9.375 22.9167 8.90625 22.9167 8.33333V7.29167H23.9583C24.5312 7.29167 25 6.82292 25 6.25C25 5.67708 24.5312 5.20833 23.9583 5.20833H22.9167ZM8.33333 8.33333C10.6354 8.33333 12.5 6.46875 12.5 4.16667C12.5 1.86458 10.6354 0 8.33333 0C6.03125 0 4.16667 1.86458 4.16667 4.16667C4.16667 6.46875 6.03125 8.33333 8.33333 8.33333ZM8.33333 9.375C5.55208 9.375 0 10.7708 0 13.5417V16.6667H16.6667V13.5417C16.6667 10.7708 11.1146 9.375 8.33333 9.375ZM13.0312 0.0520835C13.9896 1.15625 14.5833 2.59375 14.5833 4.16667C14.5833 5.73958 13.9896 7.17708 13.0312 8.28125C15.0729 8.02083 16.6667 6.29167 16.6667 4.16667C16.6667 2.04167 15.0729 0.3125 13.0312 0.0520835ZM17.2188 10.2396C18.1458 11.1042 18.75 12.1875 18.75 13.5417V16.6667H20.8333V13.5417C20.8333 12.0312 19.1771 10.9271 17.2188 10.2396Z"
                fill="#4c5155"
              />
            </svg>
            {{ $t('ONBOARDING.TEAM_MEMBERS.TITLE') }}
          </h2>
          <p class="intro-body">
            {{ $t('ONBOARDING.TEAM_MEMBERS.DESCRIPTION') }}
          </p>
          <div @click="close">
            <router-link :to="newAgentURL" class="onboarding--link" @click="close">
              {{ $t('ONBOARDING.TEAM_MEMBERS.NEW_LINK') }}
              <img src="./icon/cursor.svg" alt="SVG" class="w-4 h-4 ml-1" />
            </router-link>
          </div>
        </div>
        <div class="features-item">
          <h2 class="block-title text-black-900 dark:text-slate-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              class="emoji"
            >
              <mask
                id="mask0_1083_389"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="1"
                y="2"
                width="22"
                height="21"
              >
                <path
                  d="M2.5 15L5 3H19L21.5 15"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2.5 15H7.455L8.3635 18H15.6365L16.5455 15H21.5V21.5H2.5V15Z"
                  fill="white"
                  stroke="white"
                  stroke-width="2"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 10L12 13M12 13L15 10M12 13V7"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </mask>
              <g mask="url(#mask0_1083_389)">
                <path d="M0 0H24V24H0V0Z" fill="#4c5155" />
              </g>
            </svg>
            {{ $t('ONBOARDING.INBOXES.TITLE') }}
          </h2>
          <p class="intro-body">
            {{ $t('ONBOARDING.INBOXES.DESCRIPTION') }}
          </p>
          <div @click="close">
            <router-link :to="newInboxURL" class="onboarding--link" @click="close">
              {{ $t('ONBOARDING.INBOXES.NEW_LINK') }}
              <img src="./icon/cursor.svg" alt="SVG" class="w-4 h-4 ml-1" />
            </router-link>
          </div>
        </div>
        <div class="features-item">
          <h2 class="block-title text-black-900 dark:text-slate-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              class="emoji"
            >
              <path
                d="M17.13 18.15L16.62 17.64C16.44 17.46 16.2252 17.37 15.9756 17.37C15.726 17.37 15.5108 17.46 15.33 17.64C15.15 17.82 15.06 18.03 15.06 18.27C15.06 18.51 15.15 18.72 15.33 18.9L16.5 20.07C16.68 20.25 16.89 20.34 17.13 20.34C17.37 20.34 17.58 20.25 17.76 20.07L20.67 17.22C20.85 17.04 20.94 16.8248 20.94 16.5744C20.94 16.324 20.85 16.1092 20.67 15.93C20.49 15.75 20.2748 15.66 20.0244 15.66C19.774 15.66 19.5592 15.75 19.38 15.93L17.13 18.15ZM16.8 7.2C17.14 7.2 17.4252 7.0848 17.6556 6.8544C17.886 6.624 18.0008 6.3392 18 6C18 5.66 17.8848 5.3748 17.6544 5.1444C17.424 4.914 17.1392 4.7992 16.8 4.8H4.8C4.46 4.8 4.1748 4.9152 3.9444 5.1456C3.714 5.376 3.5992 5.6608 3.6 6C3.6 6.34 3.7152 6.6252 3.9456 6.8556C4.176 7.086 4.4608 7.2008 4.8 7.2H16.8ZM18 24C16.34 24 14.9252 23.4148 13.7556 22.2444C12.586 21.074 12.0008 19.6592 12 18C12 16.34 12.5852 14.9248 13.7556 13.7544C14.926 12.584 16.3408 11.9992 18 12C19.66 12 21.0752 12.5852 22.2456 13.7556C23.416 14.926 24.0008 16.3408 24 18C24 19.66 23.4148 21.0752 22.2444 22.2456C21.074 23.416 19.6592 24.0008 18 24ZM2.4 2.03735e-06H19.2C19.86 2.03735e-06 20.4252 0.235202 20.8956 0.705602C21.366 1.176 21.6008 1.7408 21.6 2.4V10.41C21.04 10.13 20.4548 9.9248 19.8444 9.7944C19.234 9.664 18.6192 9.5992 18 9.6H4.8C4.46 9.6 4.1748 9.7152 3.9444 9.9456C3.714 10.176 3.5992 10.4608 3.6 10.8C3.6 11.14 3.7152 11.4252 3.9456 11.6556C4.176 11.886 4.4608 12.0008 4.8 12H12.12C11.78 12.34 11.4652 12.71 11.1756 13.11C10.886 13.51 10.6308 13.94 10.41 14.4H4.8C4.46 14.4 4.1748 14.5152 3.9444 14.7456C3.714 14.976 3.5992 15.2608 3.6 15.6C3.6 15.94 3.7152 16.2252 3.9456 16.4556C4.176 16.686 4.4608 16.8008 4.8 16.8H9.69C9.65 17 9.6248 17.1952 9.6144 17.3856C9.604 17.576 9.5992 17.7808 9.6 18C9.6 18.84 9.7152 19.6452 9.9456 20.4156C10.176 21.186 10.5208 21.9208 10.98 22.62C10.88 22.64 10.7748 22.6248 10.6644 22.5744C10.554 22.524 10.4592 22.4592 10.38 22.38L9.42 21.42C9.3 21.3 9.16 21.24 9 21.24C8.84 21.24 8.7 21.3 8.58 21.42L7.62 22.38C7.5 22.5 7.36 22.56 7.2 22.56C7.04 22.56 6.9 22.5 6.78 22.38L5.82 21.42C5.7 21.3 5.56 21.24 5.4 21.24C5.24 21.24 5.1 21.3 4.98 21.42L4.02 22.38C3.9 22.5 3.76 22.56 3.6 22.56C3.44 22.56 3.3 22.5 3.18 22.38L2.22 21.42C2.1 21.3 1.96 21.24 1.8 21.24C1.64 21.24 1.5 21.3 1.38 21.42L0.42 22.38L0 22.65V2.4C0 1.74 0.2352 1.1748 0.7056 0.704402C1.176 0.234002 1.7408 -0.000797963 2.4 2.03735e-06Z"
                fill="#4c5155"
              />
            </svg>
            {{ $t('ONBOARDING.LABELS.TITLE') }}
          </h2>
          <p class="intro-body">
            {{ $t('ONBOARDING.LABELS.DESCRIPTION') }}
          </p>
          <div @click="close">
            <router-link :to="newLabelsURL" class="onboarding--link" @click="close">
              {{ $t('ONBOARDING.LABELS.NEW_LINK') }}
              <img src="./icon/cursor.svg" alt="SVG" class="w-4 h-4 ml-1" />
            </router-link>
          </div>
        </div>

        <div class="features-item ml-20 mr-20">
          <h2 class="block-title text-black-900 dark:text-slate-200 text-lg">
            {{ $t('ONBOARDING.FOOTER.DESCRIPTION') }}
            <img
              src="./icon/helpIcon.svg"
              alt="SVG"
              class="w-6 h-6 pl-1 pr-1 fill-slate-700"
            />
            {{ $t('ONBOARDING.FOOTER.DESCRIPTION2') }}
          </h2>
          <div @click="close">
            <router-link :to="newHomeURL" class="onboarding--link flex justify-center">
              {{ $t('ONBOARDING.FOOTER.NEW_LINK') }}
              <img src="./icon/cursor.svg" alt="SVG" class="w-4 h-4 ml-2" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import accountMixin from '../../../mixins/account';

export default {
  mixins: [accountMixin],
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    newInboxURL() {
      return this.addAccountScoping('settings/inboxes/new');
    },
    newAgentURL() {   
      return this.addAccountScoping('settings/agents/list');
    },
    newLabelsURL() {    
      return this.addAccountScoping('settings/labels/list');
    },
    newHomeURL() {    
      return this.addAccountScoping('dashboard');
    },
  },
  methods: {
    close(){
      this.$emit('close-modal-button')
    }
  }

};
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;800&display=swap');

.onboarding-wrap {
  display: flex;
  font-size: var(--font-size-small);
  font-family: Poppins;
  justify-content: center;
  overflow: auto;
  text-align: left;
}
.onboarding {
  height: 100vh;
}

.scroll-wrap {
  padding: var(--space-larger) 8.5rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.features-item {
  margin-bottom: var(--space-large);
}

.features-item-footer {
  margin-bottom: var(--space-large);
}

.conversation--title {
  margin-left: var(--space-minus-smaller);
}

.page-title {
  font-size: var(--font-size-big);
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-one);
}

.block-title {
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-smaller);
  margin-left: var(--space-minus-large);
}

.intro-body {
  margin-bottom: var(--space-small);
  line-height: 1.5;
}

.onboarding--link {
  color: var(--g-1000);
  font-weight: var(--font-weight-medium);
  text-decoration: underline;
}

.emoji {
  width: var(--space-large);
  display: inline-block;
  fill: hsl(207, 5.6%, 31.6%);
}
</style>
